import { createTheme, type Theme } from "@mui/material/styles";

/**
 * `baseTheme` with every text in `fontFamily`, all other values kept. Used where one subtree must read in another
 * typeface than the app's: the hospital demo (DM Sans) and a public careers page (the department's chosen font).
 *
 * Sets fontFamily on the root AND every variant explicitly: MUI bakes each variant's font at build time and
 * body1/body2/subtitle don't inherit the root, so they'd otherwise keep the base font. A few MUI inputs bake their own
 * font too and ignore the variants, so their roots are forced as well (form labels, inputs, chips, menu items, tabs).
 */
export const withFontFamily = (baseTheme: Theme, fontFamily: string): Theme =>
	createTheme(baseTheme, {
		typography: {
			fontFamily,
			h1: { fontFamily },
			h2: { fontFamily },
			h3: { fontFamily },
			h4: { fontFamily },
			h5: { fontFamily },
			h6: { fontFamily },
			subtitle1: { fontFamily },
			subtitle2: { fontFamily },
			body1: { fontFamily },
			body2: { fontFamily },
			button: { fontFamily },
			caption: { fontFamily },
			overline: { fontFamily },
		},
		components: {
			MuiFormLabel: { styleOverrides: { root: { "&.MuiFormLabel-root": { fontFamily } } } },
			MuiInputLabel: { styleOverrides: { root: { "&.MuiInputLabel-root": { fontFamily } } } },
			MuiInputBase: { styleOverrides: { root: { fontFamily } } },
			MuiChip: { styleOverrides: { root: { fontFamily } } },
			MuiMenuItem: { styleOverrides: { root: { fontFamily } } },
			MuiTab: { styleOverrides: { root: { fontFamily } } },
		},
	});
